import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
   state: {
      isLoading: false,
      notification: {
         title: '',
         content: '',
         closeButton: ''
      },
      scanText: '',
      messSuccessFtth: '',
      qrMode: 'manual',
      phoneScratchCard: '',
      customerName: '',
      receiverIsdn: '',
      ftthPackage: '',
      ftthPackageCode: '',
      linkedFtthAccountList: null,
      activeFTTH: false,
      ftthAccountNo: '',
      qrFtthInfo:null,
      qrCodeCheck:'',
      qrCode:'',
      qrFtthInfoLogin:null,
      infoCusFtthPackage: {},
      errorReportItem: null,
      listRate: null,
      listSuggest: null,
      urlImage: '',
      urlImageCrop: '',
      imageType: '',
      dataResInfo: {
         standard: 1,
         address: 'vn',
         Precinct: null,
         District: null,

         name: null,
         subType: 1,
         avatar_url: null,
         phone: null,

         phoneNumber: null,
         cusType: null,
         idType: null,
         idNo: null,
         fullName: '-',
         gender: null,
         doB: null,
         nationalities: null,
         Province: null,

         image1: './images/img-register-upload-1.png',
         image2: './images/img-register-upload-1.png',
         image3: './images/img-register-upload-2.png'
      },
      packageActiveTab: 1,
      change_to_prepaid: {
         cusId: '',
         contactPhone: '',
         cusName: '',
         birthOfDay: '',
         fullAddress: '',
         provinceCode: '01',
         districtCode: '01',
         precinctCode: '01',
         sex: 'M',
         appCode: 'APP_UNITEL'
      },
      step1: {
         newProductCode: '',
         newSubType: '',
         listPackage: [],
         listSubType: []
      },
      step2: {
         isdnUmoney: ''
      },
      step3: {
         transId: '',
         timestamp: '',
         transDate: '',
         serviceCode: '',
         account: ''
      },
      change_to_postpaid: {
         lstCusProfile: []
      },
      change_simcard: {
         step1: {
            lstChangeSim: []
         },
         step2: {
            phone: '',
            isdnContact: '',
            isdnContact1: '',
            isdnContact2: '',
            isdnContact3: '',
            portraitImg: '',
            idImg: '',
            newSerialImg: '',
            gender: 0,
            sex: 'M',
            date_of_birth: '',
            id_issued_date: '',
            issued_office: '',
            name: '',
            image1: './images/idtype.png',
            image2: './images/image_client1.png',
            image3: './images/img-register-upload-3.png',
            idType: null,
            idNum: '',
            serial_new_simcard: '',
            contact_number: ''
         },
         step3: {
            message: ''
         }
      },
      change_scartch_card: {
         step1: {
            lstChangeScartchCard: []
         },
         step2: {
            phone: '',
            idImg: '',
            name: '',
            image1: './images/idtype.png',
            image2: './images/img-register-upload-4.png',
            idType: null,
            idNum: '',
            serialCard: ''
         },
         step3: {
            message: ''
         }
      },
      buy_sim: {
         payment_type: null,
         selected_sim: null,
         order_info: null
      },
      buy_ftth: {
         payment_type: null,
         selected_ftth: null,
         order_info: null,
         ftth_type: null
      },
      buy_device: {
         payment_type: null,
         selected_device: null,
         order_info: null
      },
      isShowOTPShopOnline: false,
      address_info: {
         province: null,
         district: null,
         precinct: null
      },
      transfer_info: null,
      account_balance: null,
      recent_transfer: [],
      contract: {},
      accountFtthInfo: {},
      wifiInfo: {},
      deviceInfo: {},
      wifiIndex: null,
      statusBlockUnlock: ''
   },
   mutations: {
      SET_LOADING(state, payload) {
         if (payload) {
            state.isLoading += 1
         } else if (state.isLoading > 0) {
            state.isLoading -= 1
         }
      },
      SET_NOTIFICATION(state, payload) {
         state.notification = payload
      },
      setTextScan(state, payload) {
         state.scanText = payload
      },

      SET_MESS_SUCCESS_FTTH(state, payload) {
         state.messSuccessFtth = payload
      },
      setPhoneScratchCard(state, payload) {
         state.phoneScratchCard = payload
      },
      setCustomerName(state, payload) {
         state.customerName = payload
      },
      setReceiverIsdn(state, payload) {
         state.receiverIsdn = payload
      },
      setFtthPackage(state, payload) {
         state.ftthPackage = payload
      },
      setFtthPackageCode(state, payload) {
         state.ftthPackageCode = payload
      },
      setInfoCusFtthPackage(state, payload) {
         state.infoCusFtthPackage = payload
      },
      setUrlImage(state, payload) {
         state.urlImage = payload
      },
      setUrlImageCrop(state, payload) {
         state.urlImageCrop = payload
      },
      setImageType(state, payload) {
         state.imageType = payload
      },
      setDataResInfo(state, payload) {
         state.dataResInfo = payload
      },
      setPackageActiveTab(state, payload) {
         state.packageActiveTab = payload
      },
      setChangeToPrepaid(state, payload) {
         let item = state.change_to_prepaid
         let objectK = Object.keys(payload)
         objectK.forEach((key) => {
            item[key] = payload[key]
         })
         state.change_to_prepaid = item
      },
      setStep1(state, payload) {
         let item = state.step1
         let objectK = Object.keys(payload)
         objectK.forEach((key) => {
            item[key] = payload[key]
         })
         state.step1 = item
      },
      setStep2(state, payload) {
         let item = state.step2
         let objectK = Object.keys(payload)
         objectK.forEach((key) => {
            item[key] = payload[key]
         })
         state.step2 = item
      },
      setStep3(state, payload) {
         let item = state.step3
         let objectK = Object.keys(payload)
         objectK.forEach((key) => {
            item[key] = payload[key]
         })
         state.step3 = item
      },
      setLstCusProfile(state, payload) {
         state.change_to_postpaid.lstCusProfile = payload
      },
      setChangeSimcard(state, payload) {
         const { step, value } = payload
         let item = state.change_simcard[step]
         let objectK = Object.keys(value)
         objectK.forEach((key) => {
            item[key] = value[key]
         })
         state.change_simcard[step] = item
      },
      setChangeScratchCard(state, payload) {
         const { step, value } = payload
         let item = state.change_scartch_card[step]
         let objectK = Object.keys(value)
         objectK.forEach((key) => {
            item[key] = value[key]
         })
         state.change_scartch_card[step] = item
      },
      setSelectedSim(state, payload) {
         state.buy_sim.selected_sim = payload
      },
      setSimPaymentType(state, payload) {
         state.buy_sim.payment_type = payload
      },
      setSimOrderInfo(state, payload) {
         state.buy_sim.order_info = payload
      },
      setSelectedFtth(state, payload) {
         state.buy_ftth.selected_ftth = payload
      },
      setFtthPaymentType(state, payload) {
         state.buy_ftth.payment_type = payload
      },
      setFtthType(state, payload) {
         state.buy_ftth.ftth_type = payload
      },
      setFtthOrderInfo(state, payload) {
         state.buy_ftth.order_info = payload
      },
      setSelectedDevice(state, payload) {
         state.buy_device.selected_device = payload
      },
      setDevicePaymentType(state, payload) {
         state.buy_device.payment_type = payload
      },
      setDeviceOrderInfo(state, payload) {
         state.buy_device.order_info = payload
      },
      setIsShowOTPShopOnline(state, payload) {
         state.isShowOTPShopOnline = payload
      },
      setAddressInfoProvince(state, payload) {
         state.address_info.province = payload
      },
      setAddressInfoDistrict(state, payload) {
         state.address_info.district = payload
      },
      setAddressInfoPrecinct(state, payload) {
         state.address_info.precinct = payload
      },
      setTransferInfo(state, payload) {
         state.transfer_info = payload
      },
      setAccountBalance(state, payload) {
         state.account_balance = payload
      },
      setRecentTransfer(state, payload) {
         state.recent_transfer = payload
      },
      setActiveTabFTTH(state, payload) {
         state.activeFTTH = payload
      },
      setErrorReportItem(state, payload) {
         state.errorReportItem = payload
      },
      setListRate(state, payload) {
         state.listRate = payload
      },
      setListSuggest(state, payload) {
         state.listSuggest = payload
      },
      setContract(state, payload) {
         state.contract = payload
      },
      setAccountFtthInfo(state, payload) {
         state.accountFtthInfo = payload
      },
      setWifiInfo(state, payload) {
         state.wifiInfo = payload;
      },
      setDeviceInfo(state, payload) {
         state.deviceInfo = payload
      },
      setWifiIndex(state, payload) {
         state.wifiIndex = payload
      },
      setStatusBlockUnlock(state, payload) { 
         state.statusBlockUnlock = payload
      }
   },
   actions: {
      setLoading({ commit }, payload) {
         commit('SET_LOADING', payload)
      },
      setNotification({ commit }, payload) {
         commit('SET_NOTIFICATION', payload)
      },
      setMessSuccessFtth({ commit }, payload) {
         commit('SET_MESS_SUCCESS_FTTH', payload)
      }
   }
})

export default store
